class InvalidEnumError extends Error {

}

export default InvalidEnumError;